import React, { useEffect } from "react";
import LoginForm from "../components/LoginForm";
import PageHeading from "../utils/PageHeading";

import "react-toastify/dist/ReactToastify.css";
import useAppStore from "../store/useAppStore";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";

export default function Login() {
  const { isLogin, errorName } = useAppStore((state) => state);

  const navigate = useNavigate();
  useEffect(() => {
    useAppStore.setState({ errorName: null });
    isLogin && toast("Logging In ❇️❇️");
    setTimeout(() => {
      isLogin && navigate("/");
      useAppStore.setState({ isLogin: false });
    }, 4000);
  }, [isLogin, navigate]);

  return (
    <div>
      <PageHeading>Login</PageHeading>
      <div>{errorName && !isLogin && errorName}</div>
      <LoginForm />
    </div>
  );
}
